import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import useAddMetaTags from 'components/Dashboard/utilities/addMetaTags';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import { useRef } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useSavedItemsContext } from 'components/SavedItems/SavedItemsContext';

const useSaveItemsPageFunctions = () => {
  const { setState, state } = useSavedItemsContext();
  const { userSavedItemsFolders } = state;
  const { generalApiCall } = useGeneralApiCall();
  const { addMetaTags } = useAddMetaTags();
  const navigate = useNavigate();
  const location = useLocation();
  const showTweets = import.meta.env.VITE_APP_ENABLE_TWITTER === 'true';
  const isMounted = useRef(false);

  let savedItemsSearchDescriptor = (id) => {
    let url = new URL(window.location.href);
    url.searchParams.set('folder-id', id);
    return `?${url.searchParams.toString()}`;
  };

  const loadFolderItems = async (id, resources, source) => {
    setState('isLoadingFolder', true);
    let pathname = `/api/saved-items/saved-items?savedItemFolderId=${id}${resources?.length > 0 ? `&contentTypes=${resources.join(',')}` : ''}${showTweets ? '' : '&excludeTweets=true'}`;
    let method = 'get';
    let results = await generalApiCall({
      pathname,
      method,
      needsAuthentication: true,
      notShowErrorMessage: true,
      bigInt: true,
      requestSource: source,
    });
    if (results) {
      let finalResults = results;
      if (import.meta.env.VITE_APP_ENABLE_TWITTER === 'false') {
        finalResults = finalResults.filter((item) => item?.contentType !== 'Tweet');
      }
      setState('isLoadingFolder', false);
      setState('savedItems', finalResults);
      if (!isMounted.current) {
        isMounted.current = true;
      }
      navigate(`/saved-items${savedItemsSearchDescriptor(id)}`, { replace: true });
      let title = `Saved items - PolicyMogul`;
      addMetaTags({
        title,
        location: {
          ...location,
          search: savedItemsSearchDescriptor(id),
        },
      });
    }
  };

  const updateFolders = async () => {
    let folders = await loadFoldersCall();
    if (folders) {
      setState('userSavedItemsFolders', folders);
    }
  };

  const loadFoldersCall = async (source) => {
    let pathname = `/api/saved-items/saved-item-folders${showTweets ? '' : '?excludeTweets=true'}`;
    let method = 'get';
    let results = await generalApiCall({
      pathname,
      method,
      needsAuthentication: true,
      notShowErrorMessage: true,
      requestSource: source,
    });
    return results;
  };

  const loadFolders = async () => {
    try {
      if (userSavedItemsFolders) {
        let item;
        if (!!getUrlParam('folder-id')) {
          let folder = userSavedItemsFolders.find((item) => item.id === parseInt(getUrlParam('folder-id')));
          item = folder ?? userSavedItemsFolders[0];
        } else {
          item = userSavedItemsFolders[0];
        }
        setState('isLoadingSavedItemsList', false);
        setState('currentFolderSavedItems', item ?? {});
        navigate(`/saved-items?folder-id=${item.id}`, { replace: true });
      }
    } catch (error) {}
  };

  return {
    loadFolderItems,
    updateFolders,
    savedItemsSearchDescriptor,
    loadFolders,
    loadFoldersCall,
  };
};
export { useSaveItemsPageFunctions };
